'use client';
import React from 'react';
import PropTypes from 'prop-types';
import { useFullBleedNavScroll } from '../../hooks';
import { NavigationBar } from './NavigationBar';
import { Header } from './styles';

export const BaseHeader = ({
  topSegment,
  leftSegment,
  centerSegment,
  rightSegment,
  bottomSegment,
  logoImg = null,
  logoUrl,
  logoSrText,
  sticky = false,
  stickyBanner = false,
  hasBanner,
  bgColor = 'background.dark',
  fontColor = 'text.lightest',
  showLogo = true,
  headerVerticalPadding,
  headerHorizontalPadding,
  fullBleedNav = false,
  fullBleedLogo,
  'data-testid': dataTestId,
}) => {
  const scrolled = useFullBleedNavScroll(fullBleedNav);
  const showFullBleedLogo = Boolean(fullBleedLogo && fullBleedNav && scrolled);
  return (
    <Header
      role="banner"
      data-testid={dataTestId}
      $hasBanner={hasBanner ?? !!topSegment}
      $sticky={sticky}
      $stickyBanner={stickyBanner}
      $bgColor={bgColor}
      $fontColor={fontColor}
      $fullBleedNav={fullBleedNav}
      $scrolled={scrolled}
    >
      {topSegment}
      <div>
        <NavigationBar
          logoImg={showFullBleedLogo ? fullBleedLogo : logoImg}
          showLogo={showLogo}
          logoUrl={logoUrl}
          logoSrText={logoSrText}
          leftSegment={leftSegment}
          centerSegment={centerSegment}
          rightSegment={rightSegment}
          bgColor={bgColor}
          fontColor={fontColor}
          verticalPadding={headerVerticalPadding}
          horizontalPadding={headerHorizontalPadding}
          fullBleedNav={fullBleedNav}
        />
      </div>
      {bottomSegment}
    </Header>
  );
};

BaseHeader.displayName = 'BaseHeader';

BaseHeader.propTypes = {
  logoUrl: PropTypes.string,
  logoSrText: PropTypes.string,
  topSegment: PropTypes.node,
  leftSegment: PropTypes.node,
  centerSegment: PropTypes.node,
  rightSegment: PropTypes.node,
  bottomSegment: PropTypes.node,
  sticky: PropTypes.bool,
  stickyBanner: PropTypes.bool,
  hasBanner: PropTypes.bool,
  showLogo: PropTypes.bool,
  logoImg: PropTypes.object,
  fullBleedLogo: PropTypes.object,
  headerVerticalPadding: PropTypes.number,
  headerHorizontalPadding: PropTypes.number,
  fullBleedNav: PropTypes.bool,
  'data-testid': PropTypes.string,
};
